module.exports = __webpack_public_path__ + "files/6be75e80b3b60ec7e673921a73771514.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800italic.svg
 ** module id = 972
 ** module chunks = 0
 **/